(function () {
  "use strict";

  function initScrollTop() {
    document.querySelectorAll("[data-pw-scroll-top]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      });
    });
  }

  function initReveal() {
    var items = document.querySelectorAll(".pw-reveal");
    if (!items.length) return;
    if (!("IntersectionObserver" in window)) {
      items.forEach(function (el) { el.classList.add("pw-visible"); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("pw-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: "0px 0px 40px 0px" }
    );
    items.forEach(function (el) { io.observe(el); });
  }

  function initCounters() {
    var counters = document.querySelectorAll("[data-pw-counter]");
    if (!counters.length || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          io.unobserve(el);
          var target = parseFloat(el.getAttribute("data-pw-counter")) || 0;
          var suffix = el.getAttribute("data-pw-suffix") || "";
          var duration = 1000;
          var start = null;
          function step(ts) {
            if (!start) start = ts;
            var progress = Math.min((ts - start) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            var value = target % 1 === 0 ? Math.round(target * eased) : (target * eased).toFixed(1);
            el.textContent = value + suffix;
            if (progress < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        });
      },
      { threshold: 0.5 }
    );
    counters.forEach(function (el) { io.observe(el); });
  }

  function initCompare() {
    document.querySelectorAll("[data-pw-compare]").forEach(function (wrap) {
      var handle = wrap.querySelector(".pw-compare-handle");
      var after = wrap.querySelector(".pw-compare-after");
      if (!handle || !after) return;

      function setPosition(clientX) {
        var rect = wrap.getBoundingClientRect();
        var x = Math.min(Math.max(clientX - rect.left, 0), rect.width);
        var pct = (x / rect.width) * 100;
        after.style.clipPath = "inset(0 0 0 " + pct + "%)";
        handle.style.left = pct + "%";
      }

      var dragging = false;
      handle.addEventListener("pointerdown", function (e) {
        dragging = true;
        handle.setPointerCapture(e.pointerId);
      });
      handle.addEventListener("pointerup", function () { dragging = false; });
      handle.addEventListener("pointermove", function (e) {
        if (!dragging) return;
        setPosition(e.clientX);
      });
      wrap.addEventListener("click", function (e) {
        if (e.target === handle) return;
        setPosition(e.clientX);
      });
    });
  }

  function initProductGallery() {
    document.querySelectorAll("[data-pw-gallery]").forEach(function (gallery) {
      var main = gallery.querySelector(".pw-gallery-main img");
      var thumbs = gallery.querySelectorAll(".pw-gallery-thumb");
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          var full = thumb.getAttribute("data-full");
          var alt = thumb.getAttribute("data-alt") || "";
          if (!full) return;
          main.src = full;
          main.alt = alt;
          thumbs.forEach(function (t) { t.classList.remove("pw-active"); });
          thumb.classList.add("pw-active");
        });
      });
    });
  }

  function initVariantPicker() {
    document.querySelectorAll("[data-pw-product-form]").forEach(function (form) {
      var variantsJson = form.querySelector("[data-pw-variants]");
      if (!variantsJson) return;
      var variants;
      try { variants = JSON.parse(variantsJson.textContent); } catch (e) { return; }

      var idInput = form.querySelector("input[name='id']");
      var priceEl = document.querySelector("[data-pw-price]");
      var comparePriceEl = document.querySelector("[data-pw-compare-price]");
      var saveAmountEl = document.querySelector("[data-pw-save-amount]");
      var stickyPriceEl = document.querySelector("[data-pw-sticky-price]");
      var stickyBtn = document.querySelector("[data-pw-sticky-submit]");
      var submitBtn = form.querySelector("[data-pw-submit]");
      var selects = form.querySelectorAll("[data-pw-option]");

      function money(cents) {
        return "$" + (cents / 100).toFixed(2);
      }

      function currentSelection() {
        var values = [];
        selects.forEach(function (s) { values.push(s.value); });
        return values;
      }

      function findVariant() {
        var sel = currentSelection();
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === sel[i]; });
        });
      }

      function updateUI() {
        var variant = findVariant();
        if (!variant) return;
        idInput.value = variant.id;
        if (priceEl) {
          var parts = (variant.price / 100).toFixed(2).split(".");
          priceEl.innerHTML =
            '<span class="pw-price-cur">$</span><span class="pw-price-int">' + parts[0] +
            '</span><span class="pw-price-dec">.' + parts[1] + "</span>";
        }
        if (comparePriceEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePriceEl.textContent = money(variant.compare_at_price);
            comparePriceEl.style.display = "";
          } else {
            comparePriceEl.style.display = "none";
          }
        }
        if (saveAmountEl && variant.compare_at_price > variant.price) {
          saveAmountEl.textContent = money(variant.compare_at_price - variant.price);
        }
        if (stickyPriceEl) stickyPriceEl.textContent = money(variant.price);
        if (submitBtn) {
          var label = variant.available
            ? submitBtn.getAttribute("data-pw-label-available")
            : submitBtn.getAttribute("data-pw-label-sold-out");
          submitBtn.disabled = !variant.available;
          submitBtn.textContent = label;
          if (stickyBtn) {
            stickyBtn.disabled = !variant.available;
            stickyBtn.textContent = label;
          }
        }
      }

      selects.forEach(function (s) { s.addEventListener("change", updateUI); });
      updateUI();
    });
  }

  function initBundles() {
    var box = document.querySelector("[data-pw-bundles]");
    var qtyInput = document.querySelector("[data-pw-qty-input]");
    if (!box || !qtyInput) return;
    var stickyPrice = document.querySelector("[data-pw-sticky-price]");
    var stickyCompare = document.querySelector(".pw-sticky-compare");
    var radios = box.querySelectorAll("input[name='pw_bundle']");

    function apply() {
      var checked = box.querySelector("input[name='pw_bundle']:checked");
      if (!checked) return;
      qtyInput.value = checked.value;
      radios.forEach(function (r) {
        r.closest(".pw-bundle").classList.toggle("pw-bundle-selected", r === checked);
      });
      if (stickyPrice && checked.dataset.total) stickyPrice.textContent = checked.dataset.total;
      if (stickyCompare) {
        if (checked.dataset.compare) stickyCompare.textContent = checked.dataset.compare;
        stickyCompare.style.display = checked.dataset.compare ? "" : "none";
      }
    }

    radios.forEach(function (r) { r.addEventListener("change", apply); });
    apply();
  }

  function initStickyBuy() {
    var bar = document.querySelector("[data-pw-sticky-buy]");
    var mainBtn = document.querySelector("[data-pw-main-buy]");
    if (!bar || !mainBtn) return;
    var btn = bar.querySelector("[data-pw-sticky-submit]");
    var shown = null;
    var ticking = false;
    function update() {
      ticking = false;
      var scrolledPast = mainBtn.getBoundingClientRect().bottom < 0;
      if (scrolledPast === shown) return;
      shown = scrolledPast;
      bar.classList.toggle("pw-sticky-visible", scrolledPast);
      bar.setAttribute("aria-hidden", scrolledPast ? "false" : "true");
      if (btn) btn.tabIndex = scrolledPast ? 0 : -1;
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    update();
  }

  function boot() {
    if (window.__pwInit) return;
    window.__pwInit = true;
    initReveal();
    initCounters();
    initCompare();
    initProductGallery();
    initVariantPicker();
    initScrollTop();
    initBundles();
    initStickyBuy();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
